import msg from 'antd/lib/message';

// 处理header挡住弹窗信息
msg?.config({
    top: 75,
});

export const message = msg;
